"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var query_1 = require("@reduxjs/toolkit/query");
var alarm_1 = require("../features/apis/alarm");
var area_1 = require("../features/apis/area");
var area_library_1 = require("../features/apis/area-library");
var auth_1 = require("../features/apis/auth");
var billing_1 = require("../features/apis/billing");
var client_1 = require("../features/apis/client");
var client_invitation_1 = require("../features/apis/client-invitation");
var clone_batch_1 = require("../features/apis/clone-batch");
var clone_cutting_event_1 = require("../features/apis/clone-cutting-event");
var device_1 = require("../features/apis/device");
var facility_1 = require("../features/apis/facility");
var file_1 = require("../features/apis/file");
var grow_cycle_1 = require("../features/apis/grow-cycle");
var grow_cycle_sop_1 = require("../features/apis/grow-cycle-sop");
var integration_1 = require("../features/apis/integration");
var mother_plant_1 = require("../features/apis/mother-plant");
var permission_1 = require("../features/apis/permission");
var seed_1 = require("../features/apis/seed");
var sop_library_1 = require("../features/apis/sop-library");
var task_1 = require("../features/apis/task");
var task_category_1 = require("../features/apis/task-category");
var transaction_1 = require("../features/apis/transaction");
var user_1 = require("../features/apis/user");
var client_2 = require("../features/slices/client");
var content_dialog_1 = require("../features/slices/content-dialog");
var facility_2 = require("../features/slices/facility");
var message_dialog_1 = require("../features/slices/message-dialog");
var user_2 = require("../features/slices/user");
var notification_1 = require("../features/apis/notification");
// Cached API responses (queries and mutation results) belong to the signed-out user, so drop
// them whenever the session is cleared. Lives here rather than in the session thunk because the
// api slices import baseQueryWithReauth, which imports that thunk — a cycle that breaks at load.
var sessionListener = (0, toolkit_1.createListenerMiddleware)();
sessionListener.startListening({
    actionCreator: user_2.clearCredentials,
    effect: function (_, listenerApi) {
        var apis = [
            alarm_1.alarmApi,
            notification_1.notificationApi,
            area_1.areaApi,
            area_library_1.areaLibraryApi,
            auth_1.authApi,
            billing_1.billingApi,
            client_1.clientApi,
            client_invitation_1.clientInvitationApi,
            clone_batch_1.cloneBatchApi,
            clone_cutting_event_1.cloneCuttingEventApi,
            device_1.deviceApi,
            facility_1.facilityApi,
            file_1.fileApi,
            grow_cycle_1.growCycleApi,
            grow_cycle_sop_1.growCycleSopApi,
            integration_1.integrationApi,
            mother_plant_1.motherPlantApi,
            permission_1.permissionApi,
            seed_1.seedApi,
            sop_library_1.sopLibraryApi,
            task_1.taskApi,
            task_category_1.taskCategoryApi,
            transaction_1.transactionApi,
            user_1.userApi,
        ];
        for (var _i = 0, apis_1 = apis; _i < apis_1.length; _i++) {
            var api = apis_1[_i];
            listenerApi.dispatch(api.util.resetApiState());
        }
    },
});
exports.store = (0, toolkit_1.configureStore)({
    devTools: process.env.ENVIRONMENT !== "PROD",
    reducer: (_a = {
            user: user_2.userReducer,
            client: client_2.clientReducer,
            facility: facility_2.facilityReducer,
            messageDialog: message_dialog_1.messageDialogReducer,
            contentDialog: content_dialog_1.contentDialogReducer
        },
        _a[alarm_1.alarmApi.reducerPath] = alarm_1.alarmApi.reducer,
        _a[auth_1.authApi.reducerPath] = auth_1.authApi.reducer,
        _a[facility_1.facilityApi.reducerPath] = facility_1.facilityApi.reducer,
        _a[file_1.fileApi.reducerPath] = file_1.fileApi.reducer,
        _a[grow_cycle_1.growCycleApi.reducerPath] = grow_cycle_1.growCycleApi.reducer,
        _a[grow_cycle_sop_1.growCycleSopApi.reducerPath] = grow_cycle_sop_1.growCycleSopApi.reducer,
        _a[task_1.taskApi.reducerPath] = task_1.taskApi.reducer,
        _a[user_1.userApi.reducerPath] = user_1.userApi.reducer,
        _a[permission_1.permissionApi.reducerPath] = permission_1.permissionApi.reducer,
        _a[client_1.clientApi.reducerPath] = client_1.clientApi.reducer,
        _a[client_invitation_1.clientInvitationApi.reducerPath] = client_invitation_1.clientInvitationApi.reducer,
        _a[area_1.areaApi.reducerPath] = area_1.areaApi.reducer,
        _a[device_1.deviceApi.reducerPath] = device_1.deviceApi.reducer,
        _a[sop_library_1.sopLibraryApi.reducerPath] = sop_library_1.sopLibraryApi.reducer,
        _a[seed_1.seedApi.reducerPath] = seed_1.seedApi.reducer,
        _a[area_library_1.areaLibraryApi.reducerPath] = area_library_1.areaLibraryApi.reducer,
        _a[task_category_1.taskCategoryApi.reducerPath] = task_category_1.taskCategoryApi.reducer,
        _a[integration_1.integrationApi.reducerPath] = integration_1.integrationApi.reducer,
        _a[notification_1.notificationApi.reducerPath] = notification_1.notificationApi.reducer,
        _a[billing_1.billingApi.reducerPath] = billing_1.billingApi.reducer,
        _a[transaction_1.transactionApi.reducerPath] = transaction_1.transactionApi.reducer,
        _a[mother_plant_1.motherPlantApi.reducerPath] = mother_plant_1.motherPlantApi.reducer,
        _a[clone_cutting_event_1.cloneCuttingEventApi.reducerPath] = clone_cutting_event_1.cloneCuttingEventApi.reducer,
        _a[clone_batch_1.cloneBatchApi.reducerPath] = clone_batch_1.cloneBatchApi.reducer,
        _a),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware().prepend(sessionListener.middleware).concat([
            alarm_1.alarmApi.middleware, //
            auth_1.authApi.middleware,
            facility_1.facilityApi.middleware,
            file_1.fileApi.middleware,
            grow_cycle_1.growCycleApi.middleware,
            grow_cycle_sop_1.growCycleSopApi.middleware,
            task_1.taskApi.middleware,
            user_1.userApi.middleware,
            permission_1.permissionApi.middleware,
            client_1.clientApi.middleware,
            client_invitation_1.clientInvitationApi.middleware,
            area_1.areaApi.middleware,
            device_1.deviceApi.middleware,
            sop_library_1.sopLibraryApi.middleware,
            seed_1.seedApi.middleware,
            area_library_1.areaLibraryApi.middleware,
            task_category_1.taskCategoryApi.middleware,
            integration_1.integrationApi.middleware,
            notification_1.notificationApi.middleware,
            billing_1.billingApi.middleware,
            transaction_1.transactionApi.middleware,
            mother_plant_1.motherPlantApi.middleware,
            clone_cutting_event_1.cloneCuttingEventApi.middleware,
            clone_batch_1.cloneBatchApi.middleware,
        ]);
    },
});
// Lets queries that opt in (refetchOnFocus) refresh when the tab regains focus.
(0, query_1.setupListeners)(exports.store.dispatch);
